import React, { useRef, useState } from "react";
import { adminApi } from "../api";

export default function ImageUploadField({ label, hint, value, onChange }) {
  const fileRef = useRef();
  const [uploading, setUploading] = useState(false);

  async function handleFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const url = await adminApi.uploadImage(file);
      onChange(url);
    } catch (err) {
      alert(err.message);
    }
    setUploading(false);
    fileRef.current.value = "";
  }

  return (
    <div className="form-field">
      <label>{label}</label>
      {hint && <span className="field-hint">{hint}</span>}
      <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://... or upload"
          style={{ flex: 1 }}
        />
        <button
          type="button"
          className="btn btn-secondary"
          style={{ whiteSpace: "nowrap", padding: "0.4rem 0.75rem", fontSize: "0.8rem" }}
          onClick={() => fileRef.current.click()}
          disabled={uploading}
        >
          {uploading ? "Uploading..." : "Upload"}
        </button>
        <input ref={fileRef} type="file" accept="image/*" onChange={handleFile} style={{ display: "none" }} />
      </div>
      {value && (
        <div style={{ marginTop: "0.5rem" }}>
          <img src={value} alt="" style={{ maxHeight: 60, borderRadius: 6, border: "1px solid var(--border)" }} />
        </div>
      )}
    </div>
  );
}
